import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1;
`;

export const VisibleContainer = styled.div<{ $isCalculating: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex: 1;
  opacity: ${(props) => (props.$isCalculating ? 0 : 1)};
  transition: opacity 0.1s;
`;

export const VisibleItem = styled.div<{ $gap: number; $index: number }>`
  flex-shrink: 0;
  margin-left: ${(props) => (props.$index > 0 ? `${props.$gap}px` : '0')};
`;

export const MoreButtonContainer = styled.div<{
  $gap: number;
  $hasVisibleItems: boolean;
  $hasHiddenItems: boolean;
}>`
  flex-shrink: 0;
  position: relative;
  margin-left: ${(props) => (props.$hasVisibleItems ? `${props.$gap}px` : '0')};
  visibility: ${(props) => (props.$hasHiddenItems ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.$hasHiddenItems ? 'auto' : 'none')};
  opacity: ${(props) => (props.$hasHiddenItems ? 1 : 0)};
`;

export const OffScreenContainer = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  visibility: visible;
  pointer-events: auto;
`;

export const OffScreenItem = styled.div`
  flex-shrink: 0;
`;

export const HiddenContainer = styled.div<{ $gap: number }>`
  position: absolute;
  visibility: hidden;
  top: 0;
  left: 0;
  display: flex;
  gap: ${(props) => `${props.$gap}px`};
`;

export const HiddenItem = styled.div`
  flex-shrink: 0;
`;
